// Copyright (c) 2016 Deere & Company

import StatusChange, {getDefaultState as getStatusChangeRequestDefaultState} from '@deere/cps-it.warranty-model-factory/lib/status-change';

const StatusChangeRequest = StatusChange;

export const getDefaultState = () => getStatusChangeRequestDefaultState();

export default StatusChangeRequest;



// WEBPACK FOOTER //
// ./src/product/status-change-request/state/status-change-request.js